import type { Market , ChannelType } from '../models';
import type { MarketListItem } from '../components/SelectionBar/SelectionBar';

/** Build UI-friendly MarketListItem[] from raw Market[] for a given channel.
 *  selectedMarketCodes = disconnected market codes (backend semantics: markets with independent data).
 *  visibleMarketCodes  = explicitly visible market codes; undefined = all visible.
 */
export function buildMarketList(
  markets: Market[],
  channelType: ChannelType,
  selectedMarketCodes: number[],
  visibleMarketCodes?: number[],
): MarketListItem[] {
  return markets
    .filter((m) => m.channelIntegrationKey === channelType)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((m) => ({
      value: m.marketCode.toString(),
      label: m.marketShortName,
      visible: m.isMainMarket || !visibleMarketCodes || visibleMarketCodes.includes(m.marketCode),
      unlinked: !m.isMainMarket && selectedMarketCodes.includes(m.marketCode),
      isMainMarket: m.isMainMarket,
    }));
}

export function getMainMarketName(markets: Market[], channelType: ChannelType): string {
  const main = markets.find(
    (m) => m.isMainMarket && m.channelIntegrationKey === channelType,
  );
  return main?.marketShortName ?? '';
}

export function getMainMarketCode(markets: Market[], channelType: ChannelType): number {
  const main = markets.find(
    (m) => m.isMainMarket && m.channelIntegrationKey === channelType,
  );
  return main?.marketCode ?? 0;
}
